import { render, staticRenderFns } from "./AdditionalTaxInfo.vue?vue&type=template&id=51b1fb59&scoped=true&lang=pug&"
import script from "./AdditionalTaxInfo.vue?vue&type=script&lang=ts&"
export * from "./AdditionalTaxInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalTaxInfo.vue?vue&type=style&index=0&id=51b1fb59&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1fb59",
  null
  
)

export default component.exports